<template>
  <div class="club" @scroll="scrollHander($event)">
    <div class="back" @click="$router.push('/home')"><i></i></div>
    <div class="clubHead">
      <img
        src="https://archforce-website.oss-cn-hangzhou.aliyuncs.com/info/ClubActive/header.png"
        alt=""
      />
      <h3>A+CLUB</h3>
      <p>
        A+CLUB是华锐金融技术旗下共创共享、专业开放的技术交流社区，致力于成为金融技术爱好者和从业者学习交流行业最新动态、深入了解行业领先技术、提前试用行业领先产品的平台。
      </p>
    </div>
    <div class="activeList">
      <div
        class="activeItem"
        v-for="item in clubData"
        :key="item.id"
        @click="goActive(item.id)"
      >
        <div
          class="commonstatus"
          :class="{
            isEnd: item.status == 4,
            isPending: item.status == 1,
            notStarted: item.status == 2,
            isProgress: item.status == 3,
          }"
        >
          {{
            item.status == 4
              ? '已结束'
              : item.status == 3
              ? '进行中'
              : item.status == 2
              ? '未开始'
              : '报名中'
          }}
        </div>
        <div class="itemLeft">
          <img :src="item.imgUrl" alt="" />
        </div>
        <div class="itemRight">
          <h4>{{ item.title }}</h4>
          <p>
            <i class="time"></i>
            <span class="timeContent">{{
              $dayJs(item.releaseTime).format('YYYY-MM-DD')
            }}</span>
            <i class="address"></i>
            <span>{{ item.city }}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="noData" v-if="noDataState">
      <div class="commonLine"></div>
      <div class="text">已经到底了</div>
      <div class="commonLine"></div>
    </div>
    <div class="loading" v-if="loading">加载中..</div>
  </div>
</template>

<script>
import { clubActive } from '@/api'
export default {
  data() {
    return {
      tabType: 1,
      currentPage: 1,
      loading: false,
      noDataState: false,
      clubData: [],
    }
  },
  mounted() {
    this.getClubData(true)
  },
  beforeDestroy() {},
  methods: {
    scrollHander(eTarget) {
      if (this.noDataState) return
      if (this.loading) return
      if (this.clubData.length > 15) {
        this.noDataState = true
      }
      let { srcElement: target } = eTarget
      const { scrollTop, offsetHeight, scrollHeight } = target
      if (scrollTop + offsetHeight >= scrollHeight) {
        this.loading = true
        this.getClubData(false)
      }
    },
    async getClubData(flag = false) {
      const data = await clubActive({
        currentPage: flag ? this.currentPage : ++this.currentPage,
        pageSize: 10,
      }).finally(() => (this.loading = false))
      if (flag) {
        this.clubData = data.list
      } else {
        this.clubData = [...this.clubData, ...data.list]
      }
      this.noDataState = this.clubData.length >= data.count
    },
    goActive(id) {
      this.$router.push(`/active/${id}`)
    },
  },
}
</script>

<style lang="scss" scoped>
.club {
  height: 100vh;
  background-color: #f5f6f8;
  overflow-y: auto;
  box-sizing: border-box;
  .clubHead {
    position: relative;
    img {
      width: 100%;
      height: 220px;
    }
    h3 {
      position: absolute;
      top: 18px;
      left: 50%;
      margin-left: -35px;
      font-size: 18px;
      color: #ffffff;
    }
    p {
      position: absolute;
      left: 17px;
      right: 17px;
      bottom: 16px;
      font-size: 12px;
      font-weight: 400;
      color: #ffffff;
      line-height: 18px;
      letter-spacing: 1px;
    }
  }
  .activeList {
    .activeItem {
      border: none;
      border-radius: 0;
      background: white;
      img {
        margin-right: 15px;
        width: 109px;
        height: 69px;
      }
      .commonstatus {
        border-radius: 0;
        border-top-left-radius: 9px;
      }
    }
  }
  .noData {
    width: calc(100% - 96px);
    display: flex;
    align-items: center;
    margin: 25px auto 0px auto;
    padding-bottom: 25px;
    font-size: 12px;
    font-weight: 400;
    color: #999ca1;
    .commonLine {
      width: calc(100% - 190px);
      height: 1px;
      background: #e5e5e5;
    }
    .text {
      margin: 0 15px;
    }
  }
  .loading {
    margin: 25px 0 0 0;
    padding-bottom: 25px;
    font-size: 12px;
    font-weight: 400;
    color: #999ca1;
    text-align: center;
  }
}
</style>
